import { render, staticRenderFns } from "./DefaultEdit.vue?vue&type=template&id=67579e70&scoped=true"
import script from "./DefaultEdit.vue?vue&type=script&lang=js"
export * from "./DefaultEdit.vue?vue&type=script&lang=js"
import style0 from "./DefaultEdit.vue?vue&type=style&index=0&id=67579e70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67579e70",
  null
  
)

export default component.exports